// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.left-navigator {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 15%;
    overflow-y: auto;
    background-color: #fff;
    box-shadow: 1px 0 10px 1px rgba(0, 0, 0, 0.2);
    font-family: "Nunito Sans", Sans-serif, serif;
}

.z-index-1 {
    z-index: 1;
}

.z-index-2 {
    z-index: 2;
}

.file-storage {
    flex: auto;
    display: flex;
    align-items: end;
    justify-content: center;
}

.left-navigator::-webkit-scrollbar {
    width: 0;
}

.left-nav-icon-container {
    height: 50px;
    display: flex;
    padding: 0 20px;
    justify-content: left;
    align-items: center;
}

.left-nav-icon-container:hover {
    cursor: pointer;
    background-color: #f5f5f5;
}

.icon-title {
    color: #424242;
    font-size: 18px;
    text-align: center;
    text-wrap: nowrap;
    margin: 5px 5px 5px 10px;
}

.left-nav-icon-container img {
    width: 25px;
}

@media screen and (max-width: 1300px) {
    .left-navigator {
        width: 10%
    }
}

@media screen and (max-width: 1050px) {
    .icon-title {
        margin: 3px 0 0 0;
        font-size: 12px;
    }
}

@media screen and (max-width: 600px) {
    .left-nav-icon-container {
        height: 90%;
        width: 55px;
    }
    .file-storage {
        flex: none;
        display: block;
    }
}

@media print {
    .left-navigator {
        display: none;
    }
}`, "",{"version":3,"sources":["webpack://./src/shared/css/left-navigator.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,UAAU;IACV,gBAAgB;IAChB,sBAAsB;IACtB,6CAA6C;IAC7C,6CAA6C;AACjD;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,eAAe;IACf,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,WAAW;QACX,WAAW;IACf;IACA;QACI,UAAU;QACV,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ","sourcesContent":[".left-navigator {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    width: 15%;\n    overflow-y: auto;\n    background-color: #fff;\n    box-shadow: 1px 0 10px 1px rgba(0, 0, 0, 0.2);\n    font-family: \"Nunito Sans\", Sans-serif, serif;\n}\n\n.z-index-1 {\n    z-index: 1;\n}\n\n.z-index-2 {\n    z-index: 2;\n}\n\n.file-storage {\n    flex: auto;\n    display: flex;\n    align-items: end;\n    justify-content: center;\n}\n\n.left-navigator::-webkit-scrollbar {\n    width: 0;\n}\n\n.left-nav-icon-container {\n    height: 50px;\n    display: flex;\n    padding: 0 20px;\n    justify-content: left;\n    align-items: center;\n}\n\n.left-nav-icon-container:hover {\n    cursor: pointer;\n    background-color: #f5f5f5;\n}\n\n.icon-title {\n    color: #424242;\n    font-size: 18px;\n    text-align: center;\n    text-wrap: nowrap;\n    margin: 5px 5px 5px 10px;\n}\n\n.left-nav-icon-container img {\n    width: 25px;\n}\n\n@media screen and (max-width: 1300px) {\n    .left-navigator {\n        width: 10%\n    }\n}\n\n@media screen and (max-width: 1050px) {\n    .icon-title {\n        margin: 3px 0 0 0;\n        font-size: 12px;\n    }\n}\n\n@media screen and (max-width: 600px) {\n    .left-nav-icon-container {\n        height: 90%;\n        width: 55px;\n    }\n    .file-storage {\n        flex: none;\n        display: block;\n    }\n}\n\n@media print {\n    .left-navigator {\n        display: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
